import { createApi } from '../utils/api';
import iziToast from 'izitoast';
import { internalServerError } from '../utils/consts/pathRoutes';

const api = createApi();

export const getAllAgents = () => {
  return api.get('/agent/search')
    .then((res) => res.data)
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};

export const searchAgents = (query) => {
  return api.get(`/agent/search?query=${query}`)
    .then((res) => res.data)
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};

export const getAgentById = (id) => {
  return api.get(`/agent/${id}`)
    .then((res) => res.data)
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};

export const createAgent = (agentData) => {
  delete agentData.id;
  return api.post('/agent', agentData)
    .then((res) => {
      iziToast.success({
        message: res.data.message,
        position: "topRight"
      });
    })
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};

export const updateAgent = (id, updatedData) => {
  return api.put(`/agent/${id}`, updatedData)
    .then((res) => {
      iziToast.success({
        message: res.data.message,
        position: "topRight"
      });
    })
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};

export const deleteAgent = (id) => {
  return api.delete(`/agent/${id}`)
    .then((res) => {
      iziToast.success({
        message: res.data.message,
        position: "topRight"
      });
    })
    .catch((e) => {
      iziToast.error({
        message: internalServerError(e),
        position: "topRight",
        color: "#FFF2ED"
      });
    });
};
